import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import { extractExpirationInfo } from '../../../lib/util'
import { Badge, Row, Col } from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import FieldsetItem from '../../../components/FieldsetItem'
import FieldsetItemLarge from '../../../components/FieldsetItemLarge'
import { fetchSetupAdminUserId } from '../../../redux/css-admin/userManager/operations'

const LicenseSummary = props => {
  const {
    license,
    fetchSetupAdminUserId,
    setupAdminUserId,
    subscription,
    site,
  } = props || {}

  const [payerNsCustomerId, setPayerNsCustomerId] = useState()
  const [siteNsCustomerId, setSiteNsCustomerId] = useState('')

  //mount
  useEffect(() => {
    const { setupAdminEmail } = license || {}
    if (setupAdminEmail) {
      fetchSetupAdminUserId(setupAdminEmail)
    }
  }, [])

  useEffect(() => {
    if (subscription && subscription.payerNetsuiteCustomer) {
      setPayerNsCustomerId(subscription.payerNetsuiteCustomer.nsCustomerId)
    }
  }, [subscription])

  useEffect(() => {
    if (site && site.netSuiteCustomer) {
      setSiteNsCustomerId(site.netSuiteCustomer.nsCustomerId)
    }
  }, [site])

  // console.log('site', site)
  const { product, cancelledDate, modifiedDate } = license || {}
  const { description } = product || {}
  const { name, id: siteId, netsuiteCustomer } = site || {}
  const expiration = extractExpirationInfo(license, 'YYYY-MM-DD')
  const setupAdminEmailLink =
    !!license.setupAdminEmail && setupAdminUserId
      ? `/css-admin/users/${license.setupAdminEmail}/${setupAdminUserId}`
      : null

  return (
    <ErrorBoundary>
      <fieldset>
        <legend>Details</legend>
        <Row>
          <Col sm={4}>
            <FieldsetItem
              data={license.nsSubscriptionId}
              title="NetSuite Subscription Id"
              url={`/css-admin/subscriptions/${license.subscriptionId}`}
            />
            <FieldsetItem
              data={payerNsCustomerId}
              title="Purchaser NS Customer Id"
            />
          </Col>
          <Col sm={5}>
            <FieldsetItemLarge data={description} title="Product" />
            <FieldsetItemLarge
              data={name}
              title="Assigned Site Name"
              url={`/css-admin/sites/${siteId}`}
            />
            <FieldsetItem
              data={siteNsCustomerId}
              title="Assigned Site NS Customer ID"
              url={`/css-admin/sites/${siteId}`}
            />
            <FieldsetItem
              data={
                license.setupAdminEmail || <Badge color="warning">None</Badge>
              }
              title="Setup Admin Email"
              url={setupAdminEmailLink}
            />
          </Col>
          <Col sm={3}>
            <FieldsetItem
              color="none"
              data={expiration.startDate.formatted}
              title="Start Date"
            />
            <FieldsetItem
              color={expiration.isExpired ? 'danger' : 'none'}
              title="Expiration"
            >
              {expiration.expirationDate.formatted}
            </FieldsetItem>
            {cancelledDate && (
              <FieldsetItem
                color="warning"
                data={expiration.cancelledDate.formatted}
                title="Cancellation"
              />
            )}
            <FieldsetItem
              color="none"
              data={moment(modifiedDate).format('YYYY-MM-DD')}
              title="Modified Date"
            />{' '}
          </Col>
        </Row>
      </fieldset>
    </ErrorBoundary>
  )
}

LicenseSummary.propTypes = {
  license: PropTypes.object.isRequired,
  setupAdminUserId: PropTypes.number,
  subscription: PropTypes.object,
}

const mapStateToProps = ({ userManager }) => ({
  setupAdminUserId: userManager.setupAdminUserId,
})

const mapDispatchToProps = {
  fetchSetupAdminUserId: fetchSetupAdminUserId,
}

export default connect(mapStateToProps, mapDispatchToProps)(LicenseSummary)



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/LicenseSummary.js